<div data-testid="alarm-tile">
    <div class="zone__top border-zone">
        <floating-subtitle class="zone__name zone__name--tile font-22"
                           [text]="subtitle(65)">
        </floating-subtitle>
    </div>
    <div class="zone__status zone__status-background gradient-zone"
        data-testid="animation">
    </div>
    <div class="zone__content zone__content--alarm">
        <svg width="50" height="50"
             class="zone__svg--alarm zone__svg--alarm-animation">
            <text x="25" y="45" font-size="65" font-weight="bold"
                  text-anchor="middle">!
            </text>
        </svg>
        <floating-subtitle class="zone__alarm font-16" [text]="formatAlarmText(tile)">
        </floating-subtitle>
    </div>
    <div class="zone__footer zone__footer--temp bg-style"></div>
</div>
